import { connect } from 'react-redux';
import {
  getMedias, deleteMedia, clickMedia,
  exitSelectMode, changeUploadStatus,
} from '../actions/gallery';
import { GalleryMap } from '../presentation/GalleryMap';

const mapStateToProps = state => ({
  gallery: state.gallery,
  token: ('token' in state.session) ? state.session.token : '',
});

const mapDispatchToProps = dispatch => ({
  getMedias: () => dispatch(getMedias()),
  deleteMedia: payload => dispatch(deleteMedia(payload)),
  clickMedia: payload => dispatch(clickMedia(payload)),
  exitSelectMode: () => dispatch(exitSelectMode()),
  changeUploadStatus: payload => dispatch(changeUploadStatus(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GalleryMap);



// WEBPACK FOOTER //
// ./scripts/containers/GalleryContainer.jsx